import { makeStyles } from "@material-ui/core/styles";

const SharedStyle = makeStyles((theme) => ({
	systemContainer: {
		height: "100%",
	},
}));

export default SharedStyle;
